export default "e66279d8ee6737a3.svg"